import { useState, useEffect } from "react";
import { getScore } from "../api/questionnaireRequest";
import { useTranslation } from "../../../i18n/TranslationProvider";

const PreviousScore = ({ athleteId }) => {
  const [loading, setLoading] = useState(true);
  const [previousScores, setPreviousScores] = useState([]);
  const {t} = useTranslation();

  useEffect(() => {
    const fetchPreviousScores = async () => {
      try {
        const res = await getScore(athleteId);
        const previousScores = res.data.previous_scores;
        previousScores.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setPreviousScores(previousScores);
      } catch (err) {
        console.error("Error fetching previous scores:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPreviousScores();
  }, [athleteId]);

  if (loading) {
    return <p>Loading...</p>;
  }
  return (
    <div>
      <h6>Previous Scores:</h6>
      <p className="text-gray-600 mb-2">Scroll down to see more</p>
      <div className="border border-gray-300 rounded p-2 max-h-64 overflow-y-auto flex flex-col gap-4">
        {previousScores.length === 0 ? (
          <p className="text-center my-6 text-gray-500">
            No previous scores found.
          </p>
        ) : (
          <>
            {previousScores.map((entry) => {
              const isPull = entry.decision === "pull";
              return (
                <div
                  key={entry.created_at}
                  className={`
              p-2 rounded-lg border
              ${
                isPull
                  ? "border-red-500 bg-red-50"
                  : "border-green-500 bg-green-50"
              }
            `}
                >
                  <div className="flex items-center justify-between mb-1">
                    <p
                      className={`
                  px-2 py-0.5 rounded-full text-xs font-bold
                  ${
                    isPull ? "bg-red-500 text-white" : "bg-green-500 text-white"
                  }
                `}
                    >
                      {/* {isPull ? "PULL" : "PLAY"} */}
                      {isPull ? t("iiss.assess"): t("iiss.monitor")}

                    </p>
                    <p className="text-sm text-gray-600">
                      {new Date(entry.created_at).toLocaleString(undefined, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </p>
                  </div>
                  <p className="font-semibold text-sm">Score: {entry.score}</p>
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};

export default PreviousScore;
